import { render, staticRenderFns } from "./PracticeRequirementSummary.vue?vue&type=template&id=aa06aae2&scoped=true"
import script from "./PracticeRequirementSummary.vue?vue&type=script&lang=ts"
export * from "./PracticeRequirementSummary.vue?vue&type=script&lang=ts"
import style0 from "./PracticeRequirementSummary.vue?vue&type=style&index=0&id=aa06aae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa06aae2",
  null
  
)

export default component.exports